import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { dispatchFullLoading } from "@hooks/useFullLoading";
import fetcher from "@/common/axiosInstance";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
export var api__getSurveyData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(order_id, isFinance, isCancelled) {
    var _res$data, _res$data2;
    var params, queryString, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          dispatchFullLoading(true);
          params = new URLSearchParams();
          params.append("order_id", order_id.toString());
          params.append("status", isCancelled ? '0' : '1');
          if (isFinance) {
            params.append("finance", isFinance.toString());
          }
          queryString = params.toString();
          _context.n = 1;
          return fetcher().get("/order/get-survey?".concat(queryString));
        case 1:
          res = _context.v;
          if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 230)) {
            _context.n = 2;
            break;
          }
          throw new Error("Survey not existed");
        case 2:
          dispatchFullLoading(false);
          return _context.a(2, res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data);
      }
    }, _callee);
  }));
  return function api__getSurveyData(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var api__surveySubmitQuestion = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(order_id, survey_id, questionId, mainAnswer, otherDetails, secondaryAnswer, isComplete, isCanceled, isFinance) {
    var formData, _res$data3, res, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          dispatchButtonLoading(true);
          formData = new FormData();
          formData.append("order_id", order_id);
          formData.append("survey_id", survey_id);
          formData.append("question_id", questionId);
          formData.append("main_answer", mainAnswer);
          formData.append("is_complete", isComplete);
          formData.append("is_optional", otherDetails);
          formData.append("is_canceled", isCanceled);
          formData.append("is_finance", isFinance);
          if (secondaryAnswer.length) {
            secondaryAnswer.forEach(function (answer) {
              formData.append("secondary_answer[]", answer);
            });
          } else {
            formData.append("secondary_answer", "");
          }
          _context2.p = 1;
          _context2.n = 2;
          return fetcher().post("/order/submit-survey", formData);
        case 2:
          res = _context2.v;
          if (!((res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.code) === 200)) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, res.data.data);
        case 3:
          throw new Error("Something went wrong");
        case 4:
          _context2.p = 4;
          _t = _context2.v;
          throw new Error("Failed to submit survey:" + (_t === null || _t === void 0 ? void 0 : _t.message) || "");
        case 5:
          _context2.p = 5;
          dispatchButtonLoading(false);
          return _context2.f(5);
        case 6:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 4, 5, 6]]);
  }));
  return function api__surveySubmitQuestion(_x4, _x5, _x6, _x7, _x8, _x9, _x0, _x1, _x10) {
    return _ref2.apply(this, arguments);
  };
}();